/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateEdgeItem } from './CertificateEdgeItem';
import {
    CertificateEdgeItemFromJSON,
    CertificateEdgeItemFromJSONTyped,
    CertificateEdgeItemToJSON,
} from './CertificateEdgeItem';

/**
 * Related telephone number allocation credential
 * @export
 * @interface TNAllocationEdgedCredentialDetailedDto
 */
export interface TNAllocationEdgedCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    type?: TNAllocationEdgedCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    status?: TNAllocationEdgedCredentialDetailedDtoStatusEnum;
    /**
     * Human-readable Identifier for Credential. Set by creator of the credential
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    credentialAlias?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * Schema ID of the credential
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    schemaId?: string;
    /**
     * 
     * @type {{ [key: string]: CertificateEdgeItem; }}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    certificateChainMap?: { [key: string]: CertificateEdgeItem; };
    /**
     * Start of range of certified telephone numbers in E.164 format without '+'
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     * @deprecated
     */
    rangeStart?: string;
    /**
     * End of range of certified telephone numbers in E.164 format without '+'
     * @type {string}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     * @deprecated
     */
    rangeEnd?: string;
    /**
     * Phone numbers in TN and Campaign credentials
     * @type {object}
     * @memberof TNAllocationEdgedCredentialDetailedDto
     */
    phoneNumbers?: object;
}


/**
 * @export
 */
export const TNAllocationEdgedCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type TNAllocationEdgedCredentialDetailedDtoTypeEnum = typeof TNAllocationEdgedCredentialDetailedDtoTypeEnum[keyof typeof TNAllocationEdgedCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const TNAllocationEdgedCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type TNAllocationEdgedCredentialDetailedDtoStatusEnum = typeof TNAllocationEdgedCredentialDetailedDtoStatusEnum[keyof typeof TNAllocationEdgedCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the TNAllocationEdgedCredentialDetailedDto interface.
 */
export function instanceOfTNAllocationEdgedCredentialDetailedDto(value: object): boolean {
    return true;
}

export function TNAllocationEdgedCredentialDetailedDtoFromJSON(json: any): TNAllocationEdgedCredentialDetailedDto {
    return TNAllocationEdgedCredentialDetailedDtoFromJSONTyped(json, false);
}

export function TNAllocationEdgedCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TNAllocationEdgedCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'credentialAlias': json['credentialAlias'] == null ? undefined : json['credentialAlias'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'certificateChainMap': json['certificateChainMap'] == null ? undefined : (mapValues(json['certificateChainMap'], CertificateEdgeItemFromJSON)),
        'rangeStart': json['rangeStart'] == null ? undefined : json['rangeStart'],
        'rangeEnd': json['rangeEnd'] == null ? undefined : json['rangeEnd'],
        'phoneNumbers': json['phoneNumbers'] == null ? undefined : json['phoneNumbers'],
    };
}

export function TNAllocationEdgedCredentialDetailedDtoToJSON(value?: TNAllocationEdgedCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'credentialAlias': value['credentialAlias'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'schemaId': value['schemaId'],
        'certificateChainMap': value['certificateChainMap'] == null ? undefined : (mapValues(value['certificateChainMap'], CertificateEdgeItemToJSON)),
        'rangeStart': value['rangeStart'],
        'rangeEnd': value['rangeEnd'],
        'phoneNumbers': value['phoneNumbers'],
    };
}

